import { IconDefinition, faExclamationTriangle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box, Button, Text } from '@domain-group/suit-theme'

import { ConfirmActionParams, confirmAction } from '@functions/entity'

type MessagePanelProps = {
  actionPayload?: ConfirmActionParams,
  buttonIcon?: IconDefinition,
  buttonText?: string,
  description?: string,
  entityProperty: boolean,
  lineHeight?: string,
  marginBottom?: string,
  marginTop?: string,
  messageIcon?: IconDefinition,
  title: string,
  updating?: boolean,
  width?: string,
}

const MessagePanel = (props: MessagePanelProps) => {
  const {
    actionPayload,
    buttonIcon,
    buttonText,
    description,
    entityProperty,
    lineHeight = '1.3',
    marginBottom,
    marginTop,
    messageIcon = faExclamationTriangle,
    title,
    updating,
  } = props

  if (!entityProperty){
    return null
  }

  return (
    <Box
      alignItems="center"
      flexDirection={['column', 'row']}
      lineHeight={lineHeight}
      marginBottom={marginBottom}
      marginTop={marginTop}
      padding="large"
      variant="white"
    >
      <Box
        alignItems="center"
        flexDirection="row"
        justifyContent="center"
        width="100%"
      >
        <Box
          alignItems="center"
          backgroundColor="orange"
          borderRadius={5}
          color="white"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={messageIcon} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text
            fontSize="small"
            marginBottom={description ? 'small' : ''}
          >
            {title}
          </Text>

          {description && (
            <Text fontSize="small" color="bodyFontLightColor" marginTop="small">
              {description}
            </Text>
          )}
        </Box>
      </Box>

      {!!actionPayload && (
        <Button
          buttonStyle="secondaryUtility"
          height="fit-content"
          icon={buttonIcon ? <FontAwesomeIcon icon={buttonIcon} /> : null}
          loading={updating}
          marginTop={['large', 0]}
          onClick={() => confirmAction(actionPayload)}
          size="medium"
          width={['100%', 'fit-content']}
        >
          {buttonText}
        </Button>
      )}
    </Box>
  )
}

export default MessagePanel
